import React from 'react';
import { FlexRow, formatNumber, SvgIcon } from '@make-software/tg-mini-app-ui';

import UsersIcon from '@/shared/assets/icons/ic-users.svg';
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';

import { ProjectRoundContainer, RoundInfoText, StyledSvgIcon, SupportedFansText } from '../styled';

interface IRoundStatCardProps {
  icon: 'users' | 'earn';
  primary: number | string;
  secondary: string;
  onClick?: () => void;
  isSecondRound?: boolean;
}

export const RoundStatCard: React.FC<IRoundStatCardProps> = ({
  icon,
  primary,
  secondary,
  onClick,
  isSecondRound
}) => {
  const noSecondary = !secondary;
  const isEarnCard = icon === 'earn';

  return (
    <ProjectRoundContainer noSecondary={noSecondary} onClick={onClick}>
      <FlexRow align="center" gap={5}>
        {!isEarnCard ? (
          <SvgIcon src={UsersIcon} size={20} />
        ) : (
          <StyledSvgIcon src={EarnIcon} size={20} isSecondRound={isSecondRound} />
        )}
        <SupportedFansText weight={3} size="lg" color="#FFFFFF" fontWeight={700} fontFamily="Inter">
          {`${formatNumber(primary)} ${isEarnCard ? `FAN tokens` : ''}`}
        </SupportedFansText>
      </FlexRow>

      {!noSecondary && (
        <RoundInfoText weight={3} size="lg" fontFamily="Inter">
          {secondary}
        </RoundInfoText>
      )}
    </ProjectRoundContainer>
  );
};
